export const SET_CUSTOMER = "setCustomer";
export const SET_CUSTOMERS = "setCustomers";
